
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon i-search",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","stroke":"currentColor","fill":"transparent","class":"icon i-search"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('circle',{staticClass:"i-search__glass",attrs:{"cx":"7.59","cy":"7.61","r":"4.11"}}),_c('path',{staticClass:"i-search__handle",attrs:{"d":"M10.51 10.5l4.01 4"}})])
          )
        }
      }
    